import React from 'react';
import moment from 'moment';

import { Box } from '@material-ui/core';

import BannerCarousel from './Banner/carousel';
import FileMoves from './Charts/FileMoves';
import PendingMoves from './Charts/PendingMoves';
import QuickAccess from './AcessoRapido';
import PreventiveHealthProgram from './PreventiveHealthProgram';

import { useGlobal } from '../../contexts/Global/context';

import * as S from './styles';

function Home() {
    const {
        dataActiveContract: { informacoesEmpresa },
    } = useGlobal();

    return (
        <S.HomeContainer display="flex" padding="0 32px 56px" sx={{ gap: 24 }}>
            <Box sx={{ flex: 2 }}>
                <S.BannerContainer>
                    <BannerCarousel />
                </S.BannerContainer>
                <PendingMoves />
                <FileMoves />
            </Box>
            <Box sx={{ flex: 1 }}>
                <S.Card>
                    <S.TextContainer>
                        <S.TextDates>
                            {moment(informacoesEmpresa.dataLimiteEnvio, 'MM/DD/YYYY').format('DD')}
                            <S.TitleCards>Dia limite para movimentações</S.TitleCards>
                        </S.TextDates>
                        <S.VerticalLine />
                        <S.TextDates>
                            {informacoesEmpresa.diaVencimentoFatura}
                            <S.TitleCards>Dia de vencimento da fatura</S.TitleCards>
                        </S.TextDates>
                    </S.TextContainer>
                </S.Card>
                <S.Card>
                    <S.TitleCard>Acesso rápido</S.TitleCard>
                    <S.QuickLinks>
                        <QuickAccess />
                    </S.QuickLinks>
                </S.Card>
                <PreventiveHealthProgram />
            </Box>
        </S.HomeContainer>
    );
}

export default Home;
